import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import userServices from "../../user/userAction";
import savingService from "../../savings/savingAction";
const initialState = {
  publicCliqs: null,
  loading: false,
  error: false,
  success: false,
  message: null,
};

export const publicCliqAction = createAsyncThunk(
  "publicCliqAction",
  (query) => {
    return savingService.getPublicCliqs(query);
  }
);

//CREATE THE SLICE

export const publicCliqSlice = createSlice({
  name: "publicCliq",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.publicCliqs = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(publicCliqAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(publicCliqAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.publicCliqs = action.payload?.data?.data;
      })
      .addCase(publicCliqAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.publicCliqs = [];
      });
  },
});

export const { reset } = publicCliqSlice.actions;

export default publicCliqSlice.reducer;
